"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var useNotification_1 = tslib_1.__importDefault(require("rc-notification/lib/useNotification"));
var __1 = require("..");
var config_provider_1 = require("../../../config-provider");
function createUseMessage(getRcNotificationInstance, getRCNoticeProps) {
    var useMessage = function () {
        // We can only get content by render
        var getPrefixCls;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function (noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 ? void 0 : innerInstance.component.add(noticeProps, holderCallback);
            },
        };
        var _a = tslib_1.__read((0, useNotification_1.default)(proxy), 2), hookNotify = _a[0], holder = _a[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls('message', customizePrefixCls);
            var target = args.key || (0, __1.getKeyThenIncreaseKey)();
            var closePromise = new Promise(function (resolve) {
                var callback = function () {
                    if (typeof args.onClose === 'function') {
                        args.onClose();
                    }
                    return resolve(true);
                };
                getRcNotificationInstance(tslib_1.__assign(tslib_1.__assign({}, args), { prefixCls: mergedPrefixCls }), function (_a) {
                    var prefixCls = _a.prefixCls, instance = _a.instance;
                    innerInstance = instance;
                    hookNotify(getRCNoticeProps(tslib_1.__assign(tslib_1.__assign({}, args), { key: target, onClose: callback }), prefixCls));
                });
            });
            var result = function () {
                if (innerInstance) {
                    innerInstance.removeNotice(target);
                }
            };
            result.then = function (filled, rejected) {
                return closePromise.then(filled, rejected);
            };
            result.promise = closePromise;
            return result;
        }
        // Fill functions
        var hookApiRef = React.useRef({});
        hookApiRef.current.open = notify;
        ['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
            return (0, __1.attachTypeApi)(hookApiRef.current, type);
        });
        return [
            hookApiRef.current,
            React.createElement(config_provider_1.ConfigConsumer, { key: "holder" }, function (context) {
                (getPrefixCls = context.getPrefixCls);
                return holder;
            }),
        ];
    };
    return useMessage;
}
exports.default = createUseMessage;
//# sourceMappingURL=useMessage.js.map